import React from "react";
import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Checkbox,
  Typography,
} from "@material-ui/core";

const OrdersTableHead = ({
  handleSort,
  orders,
}) => {
  const createSortHandler = (field) => () => {
    handleSort(field);
  };

  return (
    <TableHead>
      <TableRow>
        {[
          { label: "Order Id", field: "id" },
          { label: "Order #", field: "orderId" },
          { label: "Date", field: "timeReceived" },
          { label: "Customer", field: "customer" },
          { label: "Shipping Address", field: "shippingAddress" },
          { label: "Number of Items", field: "timeReceived" },
          { label: "Packages", field: "timeReceived" },
          { label: "", field: "timeReceived" },
        ].map(({ label, field }, index) => (
          <TableCell
            key={index}
            style={{ color: "black !important" }}
          >
            <TableSortLabel
              onClick={createSortHandler(field)}
              style={{ color: "black !important" }}
            >
              <Typography variant="body2">{label}</Typography>
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default OrdersTableHead;
